import React from 'react'
import { hydrate } from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import analytics from '@adc/analytics'
import { ApplicationContextProvider } from '@adc/ui-adc'
import config from '@adc/configment'
import * as blueprint from '@adc/blueprint'
import RouterApp from '../common/containers/routerApp'
import configureStore from '../common/store'

/*
 * Analytics is initialized here so GTM can get started sooner
 * The init call is kept in our usual app/analytics location
 * This call will check if each analytics script has already loaded
 */
analytics.init(window.CONFIGS)

// NOTE: This is finally my chance to get some routing into ApplicationShell!
if (!document.baseURI.endsWith('/offer')) {
  const store = configureStore(window.INITIAL_STATE.shellState)

  const contextProps = {
    graphWebsocket: new blueprint.primitives.GraphWebsocket(),
  }

  hydrate(
    <ApplicationContextProvider {...contextProps}>
      <Provider store={store}>
        <BrowserRouter basename={config.get('URL_BASE_PREFIX')}>
          <RouterApp experiments={window.INITIAL_STATE.experiments} />
        </BrowserRouter>
      </Provider>
    </ApplicationContextProvider>,
    window.ROOT_DOM_MOUNT
  )
}
